<template>
  <ds-dialog
    :value="active"
    max-width="800"
    persistent
    :title="title"
    icon="low_priority"
    v-on="$listeners"
  >
    <nx-list
      ref="list"
      :items="list"
      hide-flag
      dark
      condensed
    >
      <template v-slot:item-actions>
        <div class="d-flex fill-height">
          <v-icon
            color="primary"
          >
            drag_handle
          </v-icon>
        </div>
      </template>
    </nx-list>
  </ds-dialog>
</template>

<script>
import NxList from '@/components/list/List.vue';
import Sortable from 'sortablejs';
import { move } from '@/utils';

export default {
  name: 'NxEntitySortableDialog',
  components: { NxList },
  props: {
    active: {
      type: Boolean,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      grabbing: false,
    };
  },
  computed: {
    list() {
      return this.items.map(item => item.list);
    },
  },
  mounted() {
    setTimeout(() => {
      this.sortablejs = Sortable.create(this.$refs.list.$el, {
        handle: '.nx-list-item',
        onUpdate: this.onChange,
        onStart: () => {
          this.grabbing = true;
        },
        onEnd: () => {
          this.grabbing = false;
        },
      });
    }, 500);
  },
  methods: {
    onChange(event) {
      const diff = event.oldIndex - event.newIndex;
      if (diff < 0) {
        // Move down
        this.$emit('input', move(this.items, event.oldIndex, event.newIndex + 1));
      } else {
        // Move up
        this.$emit('input', move(this.items, event.oldIndex, event.newIndex));
      }
    },
  },
};
</script>
